// extracted by mini-css-extract-plugin
export var linkWrapper = "AnchorMenu-module--linkWrapper--03c76";
export var mobileMenu = "AnchorMenu-module--mobileMenu--8573d";
export var link = "AnchorMenu-module--link--7cc85";
export var button = "AnchorMenu-module--button--882a0";
export var current = "AnchorMenu-module--current--67239";